var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 31.5,
    width: 31,
    height: 31,
    rx: 15.5,
    transform: "rotate(-180 31.5 31.5)",
    fill: "white",
    stroke: "#0258a1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0042 8.99994C18.202 9.00077 18.3951 9.06022 18.559 9.17078C18.723 9.28135 18.8505 9.43805 18.9255 9.62109C19.0004 9.80412 19.0194 10.0053 18.98 10.1991C18.9406 10.3929 18.8446 10.5707 18.7042 10.7099L14.1042 15.2899C14.0105 15.3829 13.9361 15.4935 13.8853 15.6154C13.8345 15.7372 13.8084 15.8679 13.8084 15.9999C13.8084 16.132 13.8345 16.2627 13.8853 16.3845C13.9361 16.5064 14.0105 16.617 14.1042 16.7099L18.7042 21.2899C18.7979 21.3829 18.8723 21.4935 18.9231 21.6154C18.9739 21.7372 19 21.8679 19 21.9999C19 22.132 18.9739 22.2627 18.9231 22.3845C18.8723 22.5064 18.7979 22.617 18.7042 22.7099C18.5168 22.8962 18.2634 23.0007 17.9992 23.0007C17.735 23.0007 17.4816 22.8962 17.2942 22.7099L12.7042 18.1199C12.1424 17.5574 11.8268 16.7949 11.8268 15.9999C11.8268 15.2049 12.1424 14.4424 12.7042 13.8799L17.2942 9.28994C17.3876 9.19726 17.4984 9.12393 17.6203 9.07417C17.7421 9.0244 17.8726 8.99918 18.0042 8.99994Z",
    fill: "#0258a1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.7a49e73249b8b759f97a2a84367d0f59.svg";
export { ForwardRef as ReactComponent };